/*!

=========================================================
* Argon Dashboard React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState } from "react";
import classnames from "classnames";
import NumberFormat from "react-number-format"

// reactstrap components
import {
  Card,
  CardBody,
  CardTitle,
  Container,
  Row,
  Col,
  NavItem,
  NavLink,
  Nav,
  TabContent,
  TabPane,
  CardHeader,
  Button,
  FormGroup,
  InputGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
  Modal
} from "reactstrap";
import { normalizeUnits } from "moment";

const accounts = [
  {
    accountType: 1,
    accountNumber: "000123456789",
    secuence: 1,
    system: 30,
    balance: 2000000
  },
  {
    accountType: 1,
    accountNumber: "000147852369",
    secuence: 1,
    system: 30,
    balance: 2000000.25
  }
];

const contacts = [
  {
    id: 1,
    name: "Diego Alejandro Torres Niño",
    nickName: "Diego"
  },
  {
    id: 2,
    name: "Cristian Camilo Torres Niño",
    nickName: "Camilo"
  },
  {
    id: 3,
    name: "Diego Alejandro Torres Niño",
    nickName: "Diego"
  },
  {
    id: 4,
    name: "Cristian Camilo Torres Niño",
    nickName: "Camilo"
  },
  {
    id: 5,
    name: "Diego Alejandro Torres Niño",
    nickName: "Diego"
  },
  {
    id: 6,
    name: "Cristian Camilo Torres Niño",
    nickName: "Camilo"
  }
];

const contactSelected = {
  id: 1,
  name: "Diego Alejandro Torres Niño",
  nickName: "Diego"
};

const AccountsContact = [
  {
    alias: "CuenDiego",
    accountNumber: "000123456789",
    Bank: "BBVA"
  },
  {
    alias: "CuenDiego2",
    accountNumber: "0123458794564",
    Bank: "Avvillas",
  }
];

const CardAccount = props => {
  return (
    <Col lg="12" xl="12" className="pt-3">
      <Card className="mb-xl-0 shadow">
        <CardHeader className="">
          <Row>
            <div className="col-auto ml-4">
              <Row>
                <span class="mb-0">Cuenta de Ahorros No. {props.account.accountNumber}</span>
              </Row>
              <Row>
                <span class="mb-0 text-sm">Disponible <NumberFormat value={props.account.balance} displayType={'text'} thousandSeparator={true} prefix={'$'} /></span>
              </Row>
            </div>
          </Row>
        </CardHeader>
      </Card>
    </Col>

  );
};

const CardContact = props => {
  if (props.isActive) {
    return (
      <Col lg="12" xl="12" className="pt-3">
        <Card className="mb-xl-0 shadow">
          <div className="">
            <Row>
              <div className="col-auto mr-3">
                <GetInitial contact={props.contact}></GetInitial>
              </div>
              <div className="col">
                <Row>
                  <span class="mt-2 text-sm h4">{props.contact.name}</span>
                </Row>
                <Row>
                  <span class="mb-2 text-sm">{props.contact.nickName}</span>
                </Row>
              </div>
              <div className="col-auto mr-3 vertical-center">
                <Row className="m-4">
                  <a className="button"><i className="fas fa-chevron-right" /></a>
                </Row>
              </div>
            </Row>
          </div>
        </Card>
      </Col>
    );
  } else {
    return (
      <Col lg="12" xl="12" className="pt-3">
        <div className="mb-xl-0 shadow" style={{ color: '#6A736F' }}>
          <div className="">
            <Row>
              <div className="col-auto mr-3">
                <GetInitial contact={props.contact}></GetInitial>
              </div>
              <div className="col">
                <Row>
                  <span class="mt-2 text-sm h4">{props.contact.name}</span>
                </Row>
                <Row>
                  <span class="mb-2 text-sm">{props.contact.nickName}</span>
                </Row>
              </div>
            </Row>
          </div>
        </div>
      </Col>
    );
  }
};

const CardAccountContact = props => {
  return (
    <Col lg="12" xl="12" className="pt-3">
      <Card className="mb-xl-0 shadow">
        <div className="">
          <Row>
            <div className="col-auto vertical-center">
              <Row className="m-4">
                <i className="fas fa-money-bill text-primary" />
              </Row>
            </div>
            <div className="col">
              <Row>
                <span class="mt-1 text-sm h4">{props.accountContact.alias}</span>
              </Row>
              <Row>
                <span class="mt-0 mb-0 text-sm">Ahorros No. {props.accountContact.accountNumber}</span>
              </Row>
              <Row>
                <span class="mb-1 text-sm">{props.accountContact.Bank}</span>
              </Row>
            </div>
            <div className="col-auto mr-3 vertical-center">
              <Row className="m-4">
                <a className="button"><i className="fas fa-chevron-right" /></a>
              </Row>
            </div>
          </Row>
        </div>
      </Card>
    </Col>
  );
};

const GetInitial = props => {
  if (props.contact.name !== null) {
    var initial = props.contact.name.substr(0, 1);
    return <div class="icon icon-shape bg-green text-white shadow" style={{ borderRadius: 0, borderTopLeftRadius: 6 + 'px', borderBottomLeftRadius: 6 + 'px', width: 4.5 + 'rem', height: 4.5 + 'rem' }}>{initial}</div>
  } else
    return "";
}


class NavsTransfer extends React.Component {
  state = {
    tabs: 1
  };
  toggleModal = state => {
    this.setState({
      [state]: !this.state[state]
    });
  };
  toggleNavs = (e, state, index) => {
    e.preventDefault();
    this.setState({
      [state]: index
    });
  };
  render() {
    return (
      <>
        <div className="header pb-4 pt-5 pt-md-8">
          <Container fluid>
            <div className="header-body">
              <Nav
                className="justify-content-center flex-column flex-md-row"
                id="tabs-icons-text"
                pills
                role="tablist"
              >
                <NavItem>
                  <NavLink
                    aria-selected={this.state.tabs === 1}
                    className={classnames("card-body ml-2 mb-2 mb-xl-0 shadow", {
                      active: this.state.tabs === 1
                    })}
                    onClick={e => this.toggleNavs(e, "tabs", 1)}
                    href=""
                    role="tab"
                  >
                    <Row className="justify-content-center m-2">
                      <div className="icon icon-shape">
                        <img className="my-header-image mt-5" src={require("../../assets/img/illustrations/extract.svg").default} />
                      </div>
                    </Row>
                    <Row className="justify-content-center m-2">
                      <p className="mt-3 mb-0 text-bold" style={{ fontSize: 13 + 'px', width: 101 + 'px', textAlign: "center", lineHeight: 1.43 }}>
                        Extractos
                      </p>
                    </Row>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    aria-selected={this.state.tabs === 2}
                    className={classnames("card-body ml-2 mb-2 mb-xl-0 shadow", {
                      active: this.state.tabs === 2
                    })}
                    onClick={e => this.toggleNavs(e, "tabs", 2)}
                    href=""
                    role="tab"
                  >
                    <Row className="justify-content-center m-2">
                      <div className="icon icon-shape">
                        <img className="my-header-image mt-5" src={require("../../assets/img/illustrations/certificate.svg").default} />
                      </div>
                    </Row>
                    <Row className="justify-content-center m-2">
                      <p className="mt-3 mb-0 text-bold" style={{ fontSize: 13 + 'px', width: 101 + 'px', textAlign: "center", lineHeight: 1.43 }}>
                        Certificados
                      </p>
                    </Row>
                  </NavLink>
                </NavItem>
              </Nav>
            </div>
          </Container>
        </div>
        <Container >

          <TabContent activeTab={"tabs" + this.state.tabs}>
            <TabPane tabId="tabs1">
              <Container fluid>
                <Row>
                  <Col xl="3" lg="2">

                  </Col>
                  <Col xl="6" lg="8">
                    <FormGroup>
                      <select class="selectpicker" placeholder="Tipo de Docuemnto" className="form-control input-group-alternative" data-live-search="true">
                        <option data-tokens="ketchup mustard">Cuenta No. 7980897</option>
                        <option data-tokens="mustard">Cuenta No. 7980897</option>
                        <option data-tokens="frosting">Cuenta No. 7980897</option>
                      </select>
                    </FormGroup>
                    <button block size="lg" className="bg-gradient-primary text-white btn shadow btn-rounded btn-lg btn-block">
                      Generar
                    </button>
                  </Col>
                  <Col xl="3" lg="2">
                  </Col>
                </Row>
              </Container>

            </TabPane>
            <TabPane tabId="tabs2">
              <Container fluid>
                <Row>
                  <Col xl="3" lg="2">

                  </Col>
                  <Col xl="6" lg="8">
                    <FormGroup>
                      <select class="selectpicker" placeholder="Tipo de Docuemnto" className="form-control input-group-alternative" data-live-search="true">
                        <option data-tokens="ketchup mustard">Cuenta No. 7980897</option>
                        <option data-tokens="mustard">Cuenta No. 7980897</option>
                        <option data-tokens="frosting">Cuenta No. 7980897</option>
                      </select>
                    </FormGroup>
                    <FormGroup>
                      <select class="selectpicker" placeholder="Tipo de Docuemnto" className="form-control input-group-alternative" data-live-search="true">
                        <option data-tokens="ketchup mustard">Certificado de Movimientos</option>
                        <option data-tokens="mustard">Certificado de Movimientos</option>
                        <option data-tokens="frosting">Certificado de Movimientos</option>
                      </select>
                    </FormGroup>
                    <button block size="lg" className="bg-gradient-primary text-white btn shadow btn-rounded btn-lg btn-block">
                      Generar
                    </button>
                  </Col>
                  <Col xl="3" lg="2">
                  </Col>
                </Row>
              </Container>
            </TabPane>
            <TabPane tabId="tabs3">

            </TabPane>
          </TabContent>
        </Container>
      </>

    );
  }
}

export function DivStep({ children }) {
  return <>{children}</>
}


export function DivStepper({ children, ...props }) {
  const childrenArray = React.Children.toArray(children);
  const [step, setStep] = useState(0);
  const currentChild = childrenArray[step];
  if (step != childrenArray.length - 1) {
    return (
      <div {...props}>
        {currentChild}
        <div className="mt-3">
          <Button onClick={() => setStep(s => s + 1)} block size="lg" className="bg-gradient-primary text-white btn shadow btn-rounded">
            Continuar
          </Button>
        </div>
      </div>
    );
  } else {
    return (
      <div {...props}>
        {currentChild}
      </div>
    );
  }

}

export default NavsTransfer;
